// Client-only helpers for Meta Pixel ↔ CAPI deduplication (see
// docs/architecture/meta-tracking.md). Call only in the browser.

export function getCookie(name: string): string {
  const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'))
  return m?.[1] ? decodeURIComponent(m[1]) : ''
}

export function newEventId(): string {
  if (window.crypto && crypto.randomUUID) return crypto.randomUUID()
  return 'lead-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10)
}

// _fbc setzt der Pixel selbst, wenn die Seite mit ?fbclid= aufgerufen wurde.
// Fallback: fbclid aus der URL (oder aus sessionStorage) ins fbc-Format bringen.
export function getFbc(): string {
  const c = getCookie('_fbc')
  if (c) return c
  let fbclid = new URLSearchParams(window.location.search).get('fbclid')
  try {
    if (fbclid) sessionStorage.setItem('fbclid', fbclid)
    else fbclid = sessionStorage.getItem('fbclid')
  } catch (e) {}
  return fbclid ? 'fb.1.' + Date.now() + '.' + fbclid : ''
}
